import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { availableNowValue, LeadTimeValue } from '../messages/pdpDetailsMessages';

// helpers
import get from 'lodash.get';

// constants
import { ITEM_LEAD_TIME_AVAILABLE_NOW } from '../../constants/itemConstants';

function PdpSharedDetailLeadTime({ item }) {
    // 'Available Now' OR 'It will take [TIME] to make this piece'
    const leadTimeUrlLabel = get(item, 'attributes.leadTime[0].option.urlLabel');
    const leadTime = get(item, 'attributes.leadTime[0].option.name');

    if (!leadTimeUrlLabel) {
        return null;
    }
    const isAvailableNow = leadTimeUrlLabel === ITEM_LEAD_TIME_AVAILABLE_NOW;

    return (
        <span data-tn="pdp-spec-lead-time">
            {isAvailableNow ? availableNowValue : <LeadTimeValue leadTime={leadTime} />}
        </span>
    );
}

PdpSharedDetailLeadTime.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailLeadTime, {
    item: graphql`
        fragment PdpSharedDetailLeadTime_item on Item {
            attributes {
                leadTime {
                    option {
                        name
                        urlLabel
                    }
                }
            }
        }
    `,
});
